import { MenuItem } from "@mui/material";
import { State } from "@progress/kendo-data-query";
import axios from "axios";
import { faFile, faObjectUngroup } from "@fortawesome/free-solid-svg-icons";
import { ToolbarDropdownMenu } from "../../../Grid/Toolbar/ToolbarDropdownMenu";
import { useExportWithToast } from "../../../Grid/ExcelExport/useExportWithToast";
import { combinedUrls } from "../../../URL/functions";
import { spdrUrls } from "../../../URL/ApplicationUrls";
import { UppercaseButton } from "../../../Layout/Buttons/UppercaseButton";
import { KENDO_BUTTON_CLASSES } from "../../../Layout/Buttons/KendoButtons";
import { IconWithRightMargin } from "../../../Layout/Icons/IconWithRightMargin";
import { toRequestStringWithoutPage } from "../../../Grid/Extensions/kendoDataState";
import { AuthorizationPolicies } from "../../../Auth/AuthorizationPolicy";
import RenderAuthorized from "../../../Auth/RenderAuthorized";

export const spdrOverviewToolbarMenu = () =>
  function SpdrExportMenu(dataState: State) {
    const IMACS = "IMACS";
    const MSL = "MSL";

    const mslReportUrl = combinedUrls(spdrUrls.reports, `${MSL}`);
    const dataStateAsQueryString = toRequestStringWithoutPage(dataState);
    const exportMslReport = useExportWithToast(
      () =>
        axios.post(mslReportUrl, dataStateAsQueryString, {
          responseType: "blob",
        }),
      `Exporting ${MSL} Report`
    );

    const imacsReportUrl = combinedUrls(spdrUrls.reports, `${IMACS}`);
    const exportImacsReport = useExportWithToast(
      () =>
        axios.get(imacsReportUrl, {
          responseType: "blob",
        }),
      `Exporting ${IMACS} Report`
    );

    return (
      <RenderAuthorized requiredRoles={AuthorizationPolicies.RequireAdminReadOnlyNetworkRiskLaunch}>
        <ToolbarDropdownMenu text="Exports" key="ftl-routes-export-menu">
          <MenuItem>
            <UppercaseButton className={KENDO_BUTTON_CLASSES} onClick={() => exportMslReport()}>
              <IconWithRightMargin icon={faFile} />
              {`Export ${MSL} report`}
            </UppercaseButton>
          </MenuItem>

          <MenuItem>
            <UppercaseButton className={KENDO_BUTTON_CLASSES} onClick={() => exportImacsReport()}>
              <IconWithRightMargin icon={faObjectUngroup} />
              {`Export ${IMACS} report`}
            </UppercaseButton>
          </MenuItem>
        </ToolbarDropdownMenu>
      </RenderAuthorized>
    );
  };
